import React from 'react'
import QueryParamProvider from './query-param-provider'
import ReduxProvider from './redux-provider'

const WrapWithAllProviders = ({ element }) => {
  return (
    <ReduxProvider>
      <QueryParamProvider>{element}</QueryParamProvider>
    </ReduxProvider>
  )
}

export default WrapWithAllProviders
